import { useTranslation } from 'react-i18next';
import '../../Assets/scss/components/init-msg-block.scss';
import { Link } from 'react-router-dom';
import { useTheme } from '../../Context/ThemeContext';
import { useDispatch, useSelector } from "react-redux";
import encodeBase64 from "../../Helpers/encodeBase64";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { useNavigate } from "react-router-dom";
import { saveNormalWebsiteApi } from '../../Api/DomainApi/SaveNormalDomainApi';
// component to display overlay while free version is active
const FreeVersionOverlay = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
 const {
        currentWebsitePlanList,
        user,
        activeLanguage,
        accessToken,
        currentUserDiscount,
        currentWebsite,
        websites,
    } = useSelector((store: StoreProptypes) => store);
     const {theme} = useTheme()
    const planInterval = "Y";
    const smallSitePlanId = 2;
    const domain =  currentWebsite && currentWebsite?.domain; 
       const handlePurchaseWidgetPlan = (
             planID: number,
             isTrial: boolean,
             isDownGradePlan: boolean
         ) => {
             // API to save normal website
             if (accessToken && user && activeLanguage && planID) {
                 let iframeURLType: number;
                 iframeURLType = 1;
                //  if (forAddNewDomain && !isDownGradePlan) {
                //      iframeURLType = 1;
                //  } else if (
                //      planPackage &&
                //      planPackage.package_id === planID &&
                //      planPackage.subscr_interval === planInterval &&
                //      !isDownGradePlan
                //  ) {
                //      if (
                //          activePlanDomain &&
                //          ((activePlanDomain.used_canceled_discount === 1 && isCanceledPlan) ||
                //              !activePlanDomain.is_from_dashboard ||
                //              isExpired)
                //      ) {
                //          iframeURLType = 1; // reactivate plan for widget user without discount
                //      } else {
                //          iframeURLType = 10; // reactivate plan for widget user with discount
                //      }
                //  } else if (
                //      isDownGradePlan &&
                //      activePlanDomain &&
                //      !activePlanDomain.is_from_dashboard === false
                //  ) {
                //      if (
                //          activePlanDomain &&
                //          activePlanDomain.used_canceled_discount === 1 &&
                //          isCanceledPlan
                //      ) {
                //          iframeURLType = 62;
                //      } else {
                //          iframeURLType = 60;
                //      }
                //  } else {
                //      iframeURLType = 1; // reactivate plan for widget user without discount
                //  }
                 const navigateToPurchase = () => {
                    //  let domain = "";
                    //  if (newDomain) {
                    //      domain = newDomain;
                    //  } else if (activePlanDomain) {
                    //      domain = activePlanDomain.domain;
                    //  }
                    //  console.log("domain", domain);
                     const urlString = `${planID}|${currentWebsite?.domain}|${planInterval}|${user?.parent_id === 0 || user?.parent_id === 1 ? user?.id : user?.parent_id}|${
                         activeLanguage.code
                     }|${iframeURLType}${isTrial ? "||1" : ""}`;
                     const encodedString = encodeBase64(urlString);
                     navigate(`/front/package/${encodedString}${user?.parent_id === 0 || user?.parent_id === 1 ? "" : `?subUserId=${user?.id}`}`);
                 };
                    navigateToPurchase();
                //  if (domain) {
                //      saveNormalWebsiteApi(accessToken, domain, user.id, planID).then(
                //          (res) => {
                //              // check if response data is available
                //              console.log(`test: saveNormalWebsiteApi response`, res);
                //              if (res.Data) {
                //                  navigateToPurchase();
                //              }
                //          }
                //      );
                //  } else {
                //      navigateToPurchase();
                //  }
             }
     
             /* if (user && activeLanguage && planID) {
                     const urlString = `${planID}|${activePlanDomain}|${planInterval}|${user.id}|${activeLanguage.code}|1${isTrial ? "||1" : ""}`;
                     const encodedString = encodeBase64(urlString);
                     navigate(`/front/package/${encodedString}`);
                 } */
         };

    return (
        <>
            <div className='aioa_dashboard-init-msg-block d-flex align-items-center justify-content-center'>
                <div className={`upgrade-to-paid-popup-wrapper text-center rounded-4 background-dark shadow-lg p-5`}>
                    <p className='fs-4 fw-bold'>{t("Try a 10-day free trial to view all 90+ features.")}</p>
                    <a  onClick={() =>
                                                                                        handlePurchaseWidgetPlan(
                                                                                            smallSitePlanId,
                                                                                            true,
                                                                                            false
                                                                                        )
                                                                                    } className='btn btn-primary btn-lg'>{t("Start Now")}</a>
                </div>
            </div>

        </>
    )
}

export default FreeVersionOverlay;